import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["data-unit"]
const _hoisted_2 = ["data-testid", "name", "id", "autofocus", "autocomplete", "placeholder", "min", "max"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }

import {ref, computed} from 'vue';
    import {VJoyFormError} from '@maltjoy/core-vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'InputText',
  props: {
        type: {type: String, default: 'text'},
        hasError: {type: Boolean, default: false},
        autofocus: {type: Boolean, default: false},
        autocomplete: {type: String, default: 'off'},
        value: {type: [String, Number], default: ''},
        name: {type: String, required: true},
        placeholder: {type: String, default: ''},
        suffix: String,
        min: Number,
        max: Number,
        dataTestid: String,
        id: String,
    },
  emits: ["update:value", "blur", "test", "focus"],
  setup(__props, { emit: __emit }) {

    const props = __props;

    const emits = __emit;

    const input = ref(null);
    const inputValue = ref(props.value || '');

    const isNumberInput = computed((): boolean => props.type === 'number');

    const invalidMin = computed((): boolean => {
        if (!props.min || !inputValue.value) {
            return false;
        }
        return isNumberInput.value ? inputValue.value < props.min : (inputValue.value as string).length < props.min;
    });

    const invalidMax = computed((): boolean => {
        if (!props.max || !inputValue.value) {
            return false;
        }
        return isNumberInput.value ? inputValue.value > props.max : (inputValue.value as string).length > props.max;
    });

    function onInput(): void {
        if (isNumberInput.value) {
            inputValue.value = (inputValue.value as string).replace(/\D/g, '');
            emits('update:value', parseInt(inputValue.value as string, 10) || 0);
        } else {
            emits('update:value', inputValue.value);
        }
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      "data-js": "m-input",
      class: _normalizeClass(["m-input", {'m-input__unit': __props.suffix, error: __props.hasError}]),
      "data-unit": __props.suffix
    }, [
      _withDirectives(_createElementVNode("input", {
        ref_key: "input",
        ref: input,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputValue).value = $event)),
        class: _normalizeClass(["input__value", {empty: !inputValue.value}]),
        "data-testid": __props.dataTestid,
        name: __props.name,
        id: __props.id,
        autofocus: __props.autofocus,
        autocomplete: __props.autocomplete,
        placeholder: __props.placeholder,
        min: __props.min,
        max: __props.max,
        onInput: onInput,
        onBlur: _cache[1] || (_cache[1] = ($event: any) => (emits('blur'))),
        onFocus: _cache[2] || (_cache[2] = ($event: any) => (emits('focus')))
      }, null, 42, _hoisted_2), [
        [_vModelText, inputValue.value]
      ])
    ], 10, _hoisted_1),
    (invalidMin.value || invalidMax.value)
      ? (_openBlock(), _createBlock(_unref(VJoyFormError), { key: 0 }, {
          default: _withCtx(() => [
            _createElementVNode("ul", null, [
              (invalidMin.value)
                ? (_openBlock(), _createElementBlock("li", _hoisted_3, _toDisplayString(_ctx.$msg('customer.brief.form.input.number.error.min', __props.min)), 1))
                : _createCommentVNode("", true),
              (invalidMax.value)
                ? (_openBlock(), _createElementBlock("li", _hoisted_4, _toDisplayString(_ctx.$msg('customer.brief.form.input.number.error.max', __props.max)), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})